import script from "./Vote.vue?vue&type=script&setup=true&lang=ts"
export * from "./Vote.vue?vue&type=script&setup=true&lang=ts"

import "./Vote.vue?vue&type=style&index=0&id=7fc8087e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc8087e"]])

export default __exports__